import React from 'react';
import styled from 'styled-components';

import { BLUE_GRAY } from '@espacePro/constants/admin-theme';

const Subtitle = styled.div`
  font-size: 0.8em;
  color: ${BLUE_GRAY};

  [class$="multiValue"] & {
    color: #fff;
  }
`;

type OptionSubtitleLabelProps = {
  title: string,
  subtitle: string,
};

const OptionWithSubtitle = ({ title, subtitle }: OptionSubtitleLabelProps) => (
  <>
    {title}
    <Subtitle>{subtitle}</Subtitle>
  </>
);

export { OptionWithSubtitle };
